module.exports = __webpack_public_path__ + "templates/unlock.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/components/unlock/unlock.html
// module id = 363
// module chunks = 15